import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { NdcSupportFaqPage } from 'src/app/model/page/group/faq/ndc-support-faq-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-ndc-support-faq-page',
  templateUrl: './ndc-support-faq-page.component.html',
  styleUrls: ['./ndc-support-faq-page.component.scss']
})
export class NdcSupportFaqPageComponent implements OnInit {
  ndcSupportFaqPage: NdcSupportFaqPage = {} as NdcSupportFaqPage;
  BackLinkTitle: string = '';
  BackLinkURL: string = '';
  BackLinkIcon: string = '';

  constructor(private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'support-faq') {
        this.ndcSupportFaqPage.htmlTitle = title.htmlTitle;
      }
    });
    this.ndcSupportFaqPage.sections = [];
    const query = { 'fields.title': 'NDC Support Frequently Asked Questions' };
    this.contentfulService.getPageContentWithEntries(query).then((ndcSupportFaqPageEntries) => {
      this.mapBanner(ndcSupportFaqPageEntries);
      this.mapSections(ndcSupportFaqPageEntries);
    });
    this.contentfulService.getPageContentWithItems(query).then((linkItems) => {
      this.BackLinkTitle = linkItems[0]?.fields.constants[0].BackLinkTitle;
      this.BackLinkURL = linkItems[0]?.fields.constants[0].BackLinkURL;
      this.BackLinkIcon = linkItems[0]?.fields.constants[0].BackLinkIcon;
      this.ndcSupportFaqPage.htmlTitle = linkItems[0].fields.htmlTitle;
    });
  }
  private mapBanner(ndcSupportFaqPageEntries: Entry<any>[]) {
    ndcSupportFaqPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    this.ndcSupportFaqPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url
    };
  }
  private mapSections(ndcSupportFaqPageEntries: Entry<any>[]) {
    ndcSupportFaqPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.ndcSupportFaqPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#')[2];

    this.ndcSupportFaqPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }
}
